export const SET_HEADER_WHITE_ALWAYS = "SET_HEADER_WHITE_ALWAYS";
export const SET_FOOTER_VISIBLE = "SET_FOOTER_VISIBLE";
